/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font
 */

export { default as Font } from './font';
export { default as FontBackgroundColor } from './fontbackgroundcolor';
export { default as FontColor } from './fontcolor';
export { default as FontFamily } from './fontfamily';
export { default as FontSize } from './fontsize';
export { default as FontBackgroundColorEditing } from './fontbackgroundcolor/fontbackgroundcolorediting';
export { default as FontBackgroundColorUI } from './fontbackgroundcolor/fontbackgroundcolorui';
export { default as FontColorEditing } from './fontcolor/fontcolorediting';
export { default as FontColorUI } from './fontcolor/fontcolorui';
export { default as FontFamilyEditing } from './fontfamily/fontfamilyediting';
export { default as FontFamilyUI } from './fontfamily/fontfamilyui';
export { default as FontSizeEditing } from './fontsize/fontsizeediting';
export { default as FontSizeUI } from './fontsize/fontsizeui';
